<template>
  <div class="sales-card-machine">
    <page-header
      title="Vendas presenciais"
      subtitle="Gerencie vendas na máquina de cartão"
    />
    <page-container>
      <div class="d-flex justify-content-between align-items-center gap-4 mb-5">
        <div class="d-flex align-items-center order-1 order-lg-0">
          <span class="table-quantity-counter mr-5">
            Total: {{ pagination.count || 0 }}
          </span>
          <button class="btn p-0 table-refresh" @click="refresh">
            <i class="fa-solid fa-refresh" />
          </button>
        </div>

        <div class="flex-fill">
          <search-filter
            new-design
            class="flex-fill"
            placeholder="Pesquisar"
            :show-results-dropdown="false"
            @search="searching"
          />
        </div>

        <div>
          <button
            type="button"
            class="btn btn-primary px-5 px-lg-6"
            @click="newSale"
          >
            <span class="d-none d-lg-inline">
              Adicionar
            </span>
            <i class="icon-plus d-lg-none lead"></i>
          </button>
        </div>
      </div>

      <div v-if="loading" class="text-center my-9">
        <b-spinner variant="primary" />
      </div>

      <div
        v-else-if="!sales.length"
        class="container centralize-row text-center pt-6"
      >
        <div class="row justify-content-center">
          <div class="col-lg-5">
            <img
              class="d-block mb-6 mx-auto"
              src="@/assets/images/home/welcome.svg"
            />
            <template v-if="filters.search">
              <h5>Nenhum resultado encontrado</h5>
            </template>

            <template v-else>
              <h5>Você ainda não fez vendas presenciais!</h5>
            </template>
          </div>
        </div>
      </div>

      <bp-data-table v-else :columns="columns" :data="sales">
        <template #cliente="{ item }">
          <div>{{ item.name }}</div>
          <small class="d-block text-neutral-400">{{ item.email }}</small>
        </template>
        <template #produto="{ item }">
          <div v-if="item.product">{{ item.product.name }}</div>
          <small v-if="item.offer" class="d-block text-neutral-400">{{
            item.offer.name
          }}</small>
          <small v-if="item.plan" class="d-block text-neutral-400">{{
            item.plan.name
          }}</small>
        </template>
        <template #status="{ item }">
          <span v-html="statusDiplay(item)" />
        </template>
      </bp-data-table>

      <div class="d-flex justify-content-end mb-6 mt-3">
        <paginator
          ref="paginator"
          v-show="sales.length && !loading"
          :pagination="pagination"
          @on-update="onPaginationUpdate"
        />
      </div>
    </page-container>

    <responsive-modal v-model="modal" size="lg">
      <CardMachineForm
        @close="closeModal"
        @refresh="refresh"
        :sale="focusedSale"
      />
    </responsive-modal>
  </div>
</template>

<script>
import { clearObject, datesString, formatMoney } from "@/functions/helpers";
import CardMachineForm, {
  statuses
} from "@/components/sale/CardMachineForm.vue";
import { mapState } from "vuex";

export default {
  components: {
    CardMachineForm
  },
  data() {
    return {
      loading: false,
      modal: false,
      focusedSale: null,
      filters: {
        offset: 0,
        search: ""
      }
    };
  },
  filters: {
    formatDate(val) {
      if (val) val = val.replace("Z", "");
      return val ? moment(val).format("DD/MM/YYYY") : "-";
    }
  },
  computed: {
    ...mapState("product", ["products"]),
    ...mapState("cardMachine", ["sales", "pagination"]),
    columns() {
      return [
        {
          name: "Código",
          field: "code"
        },
        { name: "Cliente" },
        { name: "Produto" },
        { name: "Status" },
        {
          name: "",
          type: "menu",
          options: [
            {
              label: "Detalhes",
              icon: "icon-exclamation-outline",
              confirmation: {
                enable: false,
                text: ""
              },
              click: this.openDetails
            }
          ]
        }
      ];
    }
  },
  watch: {
    filters: {
      handler() {
        this.dispatch();
      },
      deep: true
    }
  },
  mounted() {
    this.dispatch();
  },
  methods: {
    statusDiplay({ status }) {
      const obj = statuses.find(s => s.id === status);
      return obj
        ? `<span class="badge text-light bg-${obj.class}">${obj.name}</span>`
        : status;
    },
    closeModal() {
      this.modal = false;
      this.focusedSale = null;
    },
    newSale() {
      this.focusedSale = null;
      this.modal = true;
    },
    searching(v) {
      this.filters.search = v;
      this.$refs.paginator.reset();
    },
    openDetails(item) {
      this.focusedSale = item;
      this.modal = true;
    },
    refresh() {
      this.$refs.paginator.reset();
    },
    dispatch() {
      this.loading = true;
      this.$store
        .dispatch("cardMachine/getSales", clearObject(this.filters))
        .finally(() => {
          this.loading = false;
        });
    },
    onPaginationUpdate(offset) {
      this.filters.offset = offset;
      this.dispatch();
    },
    formatMoney,
    datesString
  }
};
</script>
